import { faReorder } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SELECT_COLUMN_ID } from "@/hooks/useRowSelection";
import { Row } from "@tanstack/react-table";
import classNames from "classnames";
import { FC } from "react";
import { Button } from "react-bootstrap";
import { useDrag, useDrop } from "react-dnd";
import TableCellContent from "./TableCellContent";

interface IProps {
  row: Row<unknown>;
  reorderRow: (draggedRowIndex: number, targetRowIndex: number) => void;
}

const DraggableRow: FC<IProps> = ({ row, reorderRow }) => {
  const [, dropRef] = useDrop({
    accept: "row",
    drop: (draggedRow: Row<unknown>) => reorderRow(draggedRow.index, row.index),
  });

  const [{ isDragging }, dragRef, previewRef] = useDrag({
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    item: () => row,
    type: "row",
  });

  //* La poignée va sur la première colonne de données, pas sur la case à cocher
  const cells = row.getVisibleCells();
  const handleIndex = cells.findIndex(
    (cell) => cell.column.id !== SELECT_COLUMN_ID
  );

  return (
    <tr
      ref={previewRef} //previewRef could go here
      className={classNames("btn-reveal-trigger align-middle", {
        "formalys-row-selected": row.getIsSelected(),
      })}
      role="row"
      style={{ opacity: isDragging ? 0.5 : 1 }}
    >
      {cells.map((cell, index) => {
        if (cell.column.id === SELECT_COLUMN_ID) {
          return (
            <td key={cell.id} role="cell" className="formalys-select-cell">
              <TableCellContent cell={cell} />
            </td>
          );
        }
        // write custom props here
        return (
          <td
            key={cell.id}
            ref={index === handleIndex ? dropRef : undefined}
            role="cell"
            {...cell.getContext().cell.column.columnDef.meta?.cellProps}
            className={classNames(
              "white-space-nowrap pe-6 py-3",
              cell.getContext().cell.column.columnDef.meta?.cellProps?.className
            )}
          >
            {index === handleIndex && (
              <Button
                ref={dragRef}
                variant="link"
                className="btn-reveal-primary p-0"
              >
                <FontAwesomeIcon icon={faReorder} />
              </Button>
            )}
            <TableCellContent cell={cell} />
          </td>
        );
      })}
    </tr>
  );
};

export default DraggableRow;
